<template>
  <el-card v-loading="loading" class="page" key="hello">
    <el-button class="button" type="primary" circle icon='el-icon-plus' @click="dialogVisible = true"/>
    <el-dialog
      id="userDialog"
      title="Add User"
      :visible.sync="dialogVisible"
      width="30%"
      v-bind:append-to-body='true'
      >
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="First Name">
          <el-input v-model="form.firstName"></el-input>
        </el-form-item>
        <el-form-item label="Last Name">
          <el-input v-model="form.lastName"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="Contract">
          <el-select v-model="form.contract" placeholder="Select">
            <el-option
              v-for="item in contracts"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Role">
          <el-input v-model="form.role"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUser">Cancel</el-button>
      </span>
    </el-dialog>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        prop="firstName"
        label="First Name">
      </el-table-column>
      <el-table-column
        prop="lastName"
        label="Last Name">
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="contract"
        label="Contract"
        width="200px">
        <template slot-scope="scope">
          <el-select v-model="scope.row.contract" @change="changeContract($event, scope.row.uid)" placeholder="Select" style="width: 100%;">
            <el-option
              class="month"
              v-for="contract in contracts"
              :key="contract.id"
              :label="contract.name"
              :value="contract.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="roles"
        label="Roles">
        <template slot-scope="scope">
          <el-button @click="toggleManager(scope.row)" class="role1" :type="scope.row.roles.includes('manager') ? 'primary' : null" round>M</el-button>
          <el-button @click="toggleAdmin(scope.row)" class="role2" :type="scope.row.roles.includes('admin') ? 'primary' : null" round>A</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import {database, auth} from '../main'

export default {
  name: 'hello',
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        contract: '',
        role: ''
      },
      contracts: [],
      dialogVisible: false,
      loading: false,
      data: null
    };
  },
  computed: {
    tableData () {
      if (this.data) {
        const {data} = this
        return Object.keys(data).map(key => ({
          email: data[key].email,
          uid: key,
          role: data[key].role,
          firstName: data[key].firstName,
          lastName: data[key].lastName,
          contract: this.contracts.find(contract => contract.id === data[key].contract) ? this.contracts.find(contract => contract.id === data[key].contract).name : 'none',
          roles: data[key].roles ? Object.keys(data[key].roles) : []
        }))
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    changeContract (event, id) {
      database.ref(`/users/${id}`).update({contract: event})
    },
    async toggleManager (data) {
      if (!data.roles.includes('manager')) {
        database.ref(`/users/${data.uid}/roles`).update({manager: true})
      } else {
        database.ref(`/users/${data.uid}/roles`).update({manager: null})
      }
    },
    async toggleAdmin (data) {
      if (!data.roles.includes('admin')) {
        database.ref(`/users/${data.uid}/roles`).update({admin: true})
      } else {
        database.ref(`/users/${data.uid}/roles`).update({admin: null})
      }
    },
    getRoles (roles) {
      if (roles) {
        return Object.keys(roles)
      }
      return []
    },
    fetchData () {
      this.loading = true
      database.ref('/contracts').on('value', data => {
        const obj = data.val()
        this.contracts = Object.keys(obj).map(key => ({
          name: obj[key].name,
          id: key
        }))
      })
      database.ref('/users').on('value', data => {
        this.data = data.val()
      })
      setTimeout(() => {
        this.loading = false
      }, 600)
    },
    addUser () {
      const {email} = this.form
      auth.createUserWithEmailAndPassword(email, 'password').then(
        (data) => {
          database.ref(`users/${data.user.uid}`).set(this.form);
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      );
      this.dialogVisible = false
      this.$refs.form.resetFields()
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button {
    margin-bottom: 10px;
  }
  .role1 {
    padding: 12px 13px;
  }
  .role2 {
    padding: 12px 14px;
  }
  #userDialog {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .page {
    position: absolute;
    overflow: scroll;
    height: calc(100vh - 120px);
    width: calc(100vw - 240px)
  }
</style>



// WEBPACK FOOTER //
// src/components/Users.vue